import React from "react";
import PropTypes from "prop-types";
import Text from "./Text";

const Footer = props => {
	const textClasses = "text-defaultFooterP text-small px-2";

	return (
		<div className="px-6 pb-4 pt-8 mt-auto">
			<div className="flex justify-center mb-2 flex-wrap">
				{props.content.map((item, index) => {
					let divider = index < props.content.length - 1 ? <div className="border-x-1-grey"></div> : "";
					return (
						<div className="flex items-center justify-center flex-no-wrap" key={"footer-item-" + item.text}>
							{item.path ? (
								<a href={item.path} className={textClasses}>
									<Text content={item.text} />
								</a>
							) : (
								<p className={textClasses}>
									<Text content={item.text} />
								</p>
							)}
							{divider}
						</div>
					);
				})}
			</div>
		</div>
	);
};

Footer.propTypes = {
	content: PropTypes.array
};

export default Footer;
